var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "feed-modal",
        visible: _vm.show,
        "header-class": "my-class",
        "content-class": "modal-insta ",
        "hide-footer": true,
        "no-fade": true,
        "no-close-on-backdrop": true,
        centered: true,
        size: "xl"
      },
      on: {
        show: _vm.setupSwiper,
        shown: function($event) {
          return _vm.initSwiper()
        },
        hidden: _vm.destroySwiper
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "swiper-container" }, [
            _c("div", { staticClass: "swiper swiper-insta" }, [
              _c(
                "div",
                {
                  staticClass: "swiper-wrapper",
                  style: { visibility: _vm.showSwiper ? "visible" : "hidden" }
                },
                [
                  _vm._l(_vm.feeds, function(f, index) {
                    return _c(
                      "div",
                      { key: f.id, staticClass: "swiper-slide" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row m-0",
                            staticStyle: { height: "100%" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-7 p-0 position-relative",
                                staticStyle: { overflow: "hidden" }
                              },
                              [
                                f.mediaType == "IMAGE"
                                  ? [
                                      _c("img", {
                                        staticClass: "img-fluid w-100 rounded",
                                        attrs: {
                                          src: f.mediaUrl,
                                          "data-width": "1080",
                                          "data-height": "1080"
                                        }
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                f.mediaType == "VIDEO"
                                  ? [
                                      _c("video", {
                                        attrs: {
                                          id: "video-" + index,
                                          src: f.mediaUrl,
                                          poster: f.thumbnail,
                                          controls: "",
                                          controlsList: "nodownload",
                                          preload: "none"
                                        }
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                f.mediaType == "CAROUSEL_ALBUM"
                                  ? [
                                      !f.children.loaded
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "loader loader-no-overlay"
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "loaderinner"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      f.children.loaded
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                "inner-swiper-carousel-" + index
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "swiper-wrapper"
                                                },
                                                _vm._l(
                                                  f.children.items,
                                                  function(item) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: item.id,
                                                        staticClass:
                                                          "swiper-slide"
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass:
                                                            "img-fluid w-100 rounded",
                                                          attrs: {
                                                            src: item.mediaUrl
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "swiper-button-prev",
                                                class:
                                                  "inner-swiper-button-prev-" +
                                                  index
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "swiper-button-next",
                                                class:
                                                  "inner-swiper-button-next-" +
                                                  index
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-5 p-0" }, [
                              _c("div", { staticClass: "insta-info mt-3" }, [
                                _c("strong", { staticClass: "d-block" }, [
                                  _vm._v(_vm._s(f.owner))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        f.created,
                                        "MMMM DD, YYYY"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }, [
                                _c("p", {
                                  staticClass: "insta-description",
                                  staticStyle: {
                                    "overflow-x": "hidden",
                                    "overflow-y": "auto !important"
                                  },
                                  domProps: { innerHTML: _vm._s(f.caption) }
                                })
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v("\n            ...\n          ")
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-button-prev swiper-button-prev-main"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-button-next swiper-button-next-main"
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }